import React from 'react'
import classes from './styles.module.scss';
import { Outlet } from 'react-router-dom';

const Layout = () => {
    const theme = localStorage.getItem('theme') || 'light';
    return (
        <div className={`${classes.layout} ${classes[theme]} `}>
            <Outlet />
        </div>
    )
}

export default Layout